module.exports = __webpack_public_path__ + "images/emoji/muscle.410e6d16a6571b317b7e.png";